const style = (theme) => {
  const output = {
    root: {
      position: 'relative',
      zIndex: 1,
      width: '100vw',
      height: 'calc(var(--vh) - 100px)',
      overflow: 'hidden',
    },
    hero: {
      extend: theme.smallWrapper,
      position: 'absolute',
      zIndex: 1,
      bottom: 0,
      left: 0,
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
    },
    wrapperTitle: {
      display: 'flex',
      flexDirection: 'column',
      '& h1': {
        fontSize: 'calc(60px + 5vw)',
        fontFamily: theme.fonts[1],
        color: theme.colors[4],
        fontWeight: 400,
        textTransform: 'uppercase',
      },
    },
    subtitle: {
      marginTop: 10,
      color: theme.colors[3],
      fontSize: 20,
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {}

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    root: {
      position: 'absolute',
      top: 0,
      zIndex: 1,
      height: 'calc(var(--vh-fixed) - 20px)',
    },
    hero: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    subtitle: {
      fontSize: 18,
    },
    wrapperTitle: {
      marginBottom: 30,
      '& h1': {
        fontSize: 80,
      },
    },
  }

  return output
}

export default style
